/*
 * Home · Video player (sections/home-video.liquid). Mirrors the Replo player:
 * the play image starts the video (with sound) and is removed for good, the
 * bar toggles play/pause and mute and opens full screen. Clicking the video
 * itself does nothing, as on the live page.
 */
(function () {
  if (window.hmVideoLoaded) return;
  window.hmVideoLoaded = true;

  function init(root) {
    if (!root || root.hmVideoInit) return;
    root.hmVideoInit = true;

    var video = root.querySelector('[data-hm-video-el]');
    var cover = root.querySelector('[data-hm-video-cover]');
    var toggle = root.querySelector('[data-hm-video-toggle]');
    var mute = root.querySelector('[data-hm-video-mute]');
    var fullscreen = root.querySelector('[data-hm-video-fullscreen]');

    if (!video) {
      if (cover) cover.hidden = true;
      return;
    }

    function play() {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    function sync() {
      var playing = !video.paused && !video.ended;
      root.classList.toggle('is-playing', playing);
      root.classList.toggle('is-muted', video.muted);
      if (toggle) toggle.setAttribute('aria-label', playing ? 'Pause' : 'Play');
      if (mute) mute.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
    }

    if (cover) {
      cover.addEventListener('click', function () {
        play();
      });
    }

    video.addEventListener('play', function () {
      if (cover) cover.hidden = true;
      sync();
    });
    video.addEventListener('pause', sync);
    video.addEventListener('ended', sync);
    video.addEventListener('volumechange', sync);

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (video.paused || video.ended) play();
        else video.pause();
      });
    }

    if (mute) {
      mute.addEventListener('click', function () {
        video.muted = !video.muted;
      });
    }

    if (fullscreen) {
      fullscreen.addEventListener('click', function () {
        if (video.requestFullscreen) {
          var r = video.requestFullscreen();
          if (r && r.catch) r.catch(function () {});
        } else if (video.webkitRequestFullscreen) {
          video.webkitRequestFullscreen();
        } else if (video.webkitEnterFullscreen) {
          video.webkitEnterFullscreen();
        }
      });
    }

    sync();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-hm-video]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
